import RemoveClient from "./RemoveClient";

import type { AgencyClient } from "../../types";

interface ClientActionsProps {
  client: AgencyClient;
  action: "remove" | "edit";
  onClose: () => void;
}

export default function ClientActions({
  client,
  action,
  onClose,
}: ClientActionsProps) {
  if (action === "remove") {
    return <RemoveClient email={client.email} onBack={onClose} />;
  }

  if (action === "edit") {
    return <div />;
  }
}
